var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2765_382)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2765_382",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2765_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76973 49.0234C2.6709 49.0234 0.976562 47.4715 0.976562 45.5489C0.976562 43.6263 2.6709 42.0744 4.76973 42.0744H45.2303C47.3291 42.0744 49.0234 43.6262 49.0234 45.5489C49.0234 47.4715 47.3291 49.0234 45.2303 49.0234H4.76973ZM36.3795 33.9672V24.7017C36.3795 22.7792 38.0737 21.2272 40.1727 21.2272C42.2716 21.2272 43.9658 22.7792 43.9658 24.7017V33.9672C43.9658 35.8897 42.2716 37.4417 40.1727 37.4417C38.0737 37.4417 36.3795 35.8897 36.3795 33.9672ZM21.2068 33.9672V24.7017C21.2068 22.7792 22.9011 21.2272 24.9999 21.2272C27.0987 21.2272 28.7931 22.7792 28.7931 24.7017V33.9672C28.7931 35.8897 27.0988 37.4417 24.9999 37.4417C22.901 37.4417 21.2068 35.8897 21.2068 33.9672ZM6.03408 33.9672V24.7017C6.03408 22.7792 7.72832 21.2272 9.82725 21.2272C11.9262 21.2272 13.6204 22.7792 13.6204 24.7017V33.9672C13.6204 35.8897 11.9262 37.4417 9.82725 37.4417C7.72832 37.4417 6.03408 35.8897 6.03408 33.9672ZM4.1375 16.5941C2.39258 16.5945 0.976562 15.2973 0.976562 13.6991C0.976562 12.6336 1.63408 11.6376 2.6709 11.1511L22.6482 1.5151C23.3815 1.16066 24.1855 0.976562 25 0.976562C25.8144 0.976562 26.6184 1.16066 27.3517 1.5151L47.3291 11.1511C48.3659 11.6377 49.0234 12.6336 49.0234 13.6991C49.0234 15.2974 47.6074 16.5946 45.8877 16.5946L4.1375 16.5941Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2765_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhite);
export default __webpack_public_path__ + "static/media/account_white.f019c79e31d66e4f48fd0b70790a9071.svg";
export { ForwardRef as ReactComponent };